export default __webpack_public_path__ + "static/heroHome-5b45a2b269fe52669e76541252748fa0.webm";